import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { motion } from 'framer-motion';
import { api } from '@/lib/api';
import { FireSimple, Confetti, Lightning } from '@phosphor-icons/react';

const Bursts = () => {
  const [bursts, setBursts] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get('/bursts');
    setBursts(data.bursts);
  };
  useEffect(() => { load(); const id = setInterval(load, 8000); return () => clearInterval(id); }, []);

  const celebrate = async () => {
    setBusy(true);
    try {
      await api.post('/bursts/celebrate');
      toast.success('🎉 You sparked the network!');
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'cooldown'); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <div className="text-center mb-10">
        <FireSimple size={36} className="text-bx-legendary mx-auto" weight="duotone" />
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Burst Events</h1>
        <p className="text-white/60 mt-1">Live moments when the network ignites.</p>
      </div>

      <div className="grad-border p-6 sm:p-8 text-center mb-10 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute h-1 w-1 rounded-full bg-bx-volt"
              initial={{ x: '50%', y: '50%', opacity: 0 }}
              animate={{
                x: `${Math.random() * 100}%`, y: `${Math.random() * 100}%`,
                opacity: [0, 1, 0],
              }}
              transition={{ duration: 3, repeat: Infinity, delay: i * 0.15 }}
            />
          ))}
        </div>
        <Confetti size={32} className="text-bx-magenta mx-auto" weight="duotone" />
        <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tighter mt-3 relative">Spark a Community Celebration</h2>
        <p className="text-white/60 mt-1 text-sm relative">Trigger a moment. Once every 5 min.</p>
        <button data-testid="burst-celebrate" onClick={celebrate} disabled={busy} className="btn-primary px-7 py-3.5 rounded-full text-sm inline-flex items-center gap-2 mt-5 relative">
          <Lightning size={16} weight="fill" /> {busy ? 'Bursting…' : 'Celebrate now'}
        </button>
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">Recent bursts</h2>
      <div className="space-y-3">
        {bursts.length === 0 && <div className="text-white/60 text-sm">No bursts yet. Be the spark.</div>}
        {bursts.map((b) => (
          <motion.div
            key={b.id}
            data-testid={`burst-${b.id}`}
            initial={{ x: -20, opacity: 0 }} animate={{ x: 0, opacity: 1 }}
            className="glass rounded-xl p-4 flex items-center gap-4"
          >
            <div className={`h-12 w-12 rounded-full grid place-items-center ${
              b.type === 'milestone' ? 'bg-bx-volt/20' : 'bg-bx-magenta/20'
            }`}>
              {b.type === 'milestone' ? <Lightning size={20} weight="fill" className="text-bx-volt" /> : <Confetti size={20} weight="fill" className="text-bx-magenta" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display font-bold">{b.title}</div>
              <div className="text-xs text-white/55 mt-0.5">{b.subtitle}</div>
            </div>
            <div className="text-[10px] uppercase tracking-widest text-white/60">
              {new Date(b.ts).toLocaleTimeString()}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Bursts;
